import { ACCOUNT_MANAGEMENT_LE_ADMIN, WORKSPACE_ORG_ADMIN } from '../../../constants/roles';
import type { Organization } from '../../../contexts/OrganizationContext';
import { ORGANIZATION_TAB_ID } from '../components/EntityTabs';

export type SettingsEntity = {
  id: string;
  name: string;
};

// Returns entities whose names the user can edit, ordered by org then legal entities.
export function getEditableSettingsEntities(
  organization: Organization | undefined,
): SettingsEntity[] {
  if (!organization) {
    return [];
  }

  const isOrganizationAdmin = organization.roles.includes(WORKSPACE_ORG_ADMIN);
  const legalEntities = organization.legalEntities
    .filter(({ roles }) => isOrganizationAdmin || roles.includes(ACCOUNT_MANAGEMENT_LE_ADMIN))
    .map(({ legalEntityId, legalEntityName }) => ({
      id: legalEntityId,
      name: legalEntityName,
    }));

  if (!isOrganizationAdmin) {
    return legalEntities;
  }

  return [{ id: ORGANIZATION_TAB_ID, name: organization.organizationName }, ...legalEntities];
}
